import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=0e86d072&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./profile.scss?vue&type=style&index=0&id=0e86d072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e86d072",
  null
  
)

export default component.exports